getFirstWarrantyOption = (optionUuid, dealOptionWarranties = {}) ->
  dealOptionWarranties[optionUuid]?[0]

generateBundleCheckoutUrl = (dealUuid, optionUuid, warrantyOption) ->
  {warrantyOptionUuid} = warrantyOption

  "/checkout/bundle?type=warranty&items=#{dealUuid}:#{optionUuid}&bundles=#{warrantyOptionUuid}"

module.exports = {getFirstWarrantyOption, generateBundleCheckoutUrl}
